// utils
import { paramCase } from 'src/utils/change-case';
import { _id, _postTitles } from 'src/_mock/assets';
import { IUser } from 'src/types/khuvuc';
// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
  YEUCAU: '/yeucau',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  gptPrivacy: '/gptprivacypolicy',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/hjxMnGUJCjY7pX8lQbS7kn/%5BPreview%5D-Minimal-Web.v5.4.0?type=design&node-id=0-1&mode=design&t=2fxnS70DuiTLGzND-0',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id: string) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  post: {
    root: `/post`,
    details: (title: string) => `/post/${paramCase(title)}`,
    demo: {
      details: `/post/${paramCase(MOCK_TITLE)}`,
    },
  },
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
  },
  authDemo: {
    classic: {
      login: `${ROOTS.AUTH_DEMO}/classic/login`,
      register: `${ROOTS.AUTH_DEMO}/classic/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/classic/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/classic/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/classic/verify`,
    },
    modern: {
      login: `${ROOTS.AUTH_DEMO}/modern/login`,
      register: `${ROOTS.AUTH_DEMO}/modern/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/modern/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/modern/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/modern/verify`,
    },
  },
  yeucau: {
    root: `${ROOTS.YEUCAU}`,
  },
  // DASHBOARD
  dashboard: {
    root: `${ROOTS.DASHBOARD}/analytics`,
    mail: `${ROOTS.DASHBOARD}/mail`,
    statistical_report: `${ROOTS.DASHBOARD}/statistical-report`,
    chat: `${ROOTS.DASHBOARD}/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      statistical_report: `${ROOTS.DASHBOARD}/statistical-report`,
      location: `${ROOTS.DASHBOARD}/quan-ly-vi-tri`,

      analytics: `${ROOTS.DASHBOARD}/analytics`,
      management: `${ROOTS.DASHBOARD}/management`,
      managementDepartment: `${ROOTS.DASHBOARD}/management-department`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
      ficilities: `${ROOTS.DASHBOARD}/ficilities`,
    },
    typeRoom: {
      root: `${ROOTS.DASHBOARD}/type-room`,
      new: `${ROOTS.DASHBOARD}/type-room/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/type-room/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/type-room/${MOCK_ID}/edit`,
      },
    },
    typeService: {
      root: `${ROOTS.DASHBOARD}/type-service`,
      new: `${ROOTS.DASHBOARD}/type-service/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/type-service/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/type-service/${MOCK_ID}/edit`,
      },
    },
    service: {
      root: `${ROOTS.DASHBOARD}/service`,
      new: `${ROOTS.DASHBOARD}/service/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/service/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/service/${MOCK_ID}/edit`,
      },
    },
    khuvuc: {
      root: `${ROOTS.DASHBOARD}/khuvuc`,
      new: `${ROOTS.DASHBOARD}/khuvuc/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/khuvuc/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/khuvuc/${id}/edit`,
    },
    tang: {
      root: `${ROOTS.DASHBOARD}/tang`,
      new: `${ROOTS.DASHBOARD}/tang/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/tang/${id}`,
    },
    tailieuphanhe: {
      root: `${ROOTS.DASHBOARD}/tailieuphanhe`,
      new: `${ROOTS.DASHBOARD}/tailieuphanhe/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/tailieuphanhe/${id}`,
    },
    hangmuc: {
      root: `${ROOTS.DASHBOARD}/hangmuc`,
      new: `${ROOTS.DASHBOARD}/hangmuc/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/hangmuc/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/hangmuc/${id}/edit`,
    },
    calv: {
      root: `${ROOTS.DASHBOARD}/calv`,
      new: `${ROOTS.DASHBOARD}/calv/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/calv/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/calv/${id}/edit`,
    },
    calv_cc: {
      root: `${ROOTS.DASHBOARD}/calv_cc`,
      new: `${ROOTS.DASHBOARD}/calv_cc/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/calv_cc/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/calv_cc/${id}/edit`,
    },
    phanquyenchecklist: {
      root: `${ROOTS.DASHBOARD}/phan-ca-hang-muc`,
      new: `${ROOTS.DASHBOARD}/phan-ca-hang-muc/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/phan-ca-hang-muc/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/phan-ca-hang-muc/${id}/edit`,
    },
    sucongoai: {
      root: `${ROOTS.DASHBOARD}/su-co-ngoai`,
      // new: `${ROOTS.DASHBOARD}/phan-ca-hang-muc/new`,
      // details: (id: string) => `${ROOTS.DASHBOARD}/phan-ca-hang-muc/${id}`,
      // edit: (id: string) => `${ROOTS.DASHBOARD}/phan-ca-hang-muc/${id}/edit`,
    },
    baocaochiso: {
      root: `${ROOTS.DASHBOARD}/bao-cao-chi-so`,
      new: `${ROOTS.DASHBOARD}/bao-cao-chi-so/new`,
      thongTin: `${ROOTS.DASHBOARD}/bao-cao-chi-so/thong-tin`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/bao-cao-chi-so/${id}/edit`,
    },
    chukyduan: {
      root: `${ROOTS.DASHBOARD}/chu-ky-du-an`,
      new: `${ROOTS.DASHBOARD}/chu-ky-du-an/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/chu-ky-du-an/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/chu-ky-du-an/${id}/edit`,
    },
    giamsat: {
      root: `${ROOTS.DASHBOARD}/giamsat`,
      new: `${ROOTS.DASHBOARD}/giamsat/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/giamsat/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/giamsat/${id}/edit`,
    },

    quanlygiamsat: {
      root: `${ROOTS.DASHBOARD}/quan-ly-giam-sat`,
      details: (id: string) => `${ROOTS.DASHBOARD}/quan-ly-giam-sat/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/quan-ly-giam-sat/${id}/edit`,
    },

    checklist: {
      root: `${ROOTS.DASHBOARD}/checklist`,
      new: `${ROOTS.DASHBOARD}/checklist/new`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/checklist/lists/${id}`,
      not: (id: string) => `${ROOTS.DASHBOARD}/checklist/lists-not/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/checklist/${id}/edit`,
      lists: `${ROOTS.DASHBOARD}/checklist/lists`,
      catrongngay: `${ROOTS.DASHBOARD}/checklist/catrongngay`,
      catrongngaydetail: (Ngay: string, ID_Calv: string) =>
        `${ROOTS.DASHBOARD}/checklist/catrongngay/${Ngay}/${ID_Calv}`,
    },
    quanlytaikhoan: {
      root: `${ROOTS.DASHBOARD}/quan-ly-tai-khoan`,
      list: `${ROOTS.DASHBOARD}/quan-ly-tai-khoan/list`,
      error: `${ROOTS.DASHBOARD}/quan-ly-tai-khoan/error`,
      resetPassWord: `${ROOTS.DASHBOARD}/quan-ly-tai-khoan/resetPassWord`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/quan-ly-tai-khoan/${id}/edit`,
    },

    createUser: {
      root: `${ROOTS.DASHBOARD}/tai-khoan`,
      list: `${ROOTS.DASHBOARD}/tai-khoan/list`,
      // error: `${ROOTS.DASHBOARD}/tai-khoan/error`,
      // resetPassWord: `${ROOTS.DASHBOARD}/tai-khoan/resetPassWord`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/tai-khoan/${id}/edit`,
    },
    duan: {
      root: `${ROOTS.DASHBOARD}/duan`,
      new: `${ROOTS.DASHBOARD}/duan/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/duan/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/duan/${id}/edit`,
    },
    hsse: {
      root: `${ROOTS.DASHBOARD}/hsse`,
      admin: `${ROOTS.DASHBOARD}/hsse/admin`,
      dien_nuoc: `${ROOTS.DASHBOARD}/hsse/dien-nuoc`,
      new: `${ROOTS.DASHBOARD}/hsse/new`,
      phanquyen: `${ROOTS.DASHBOARD}/hsse/phanquyen`,
      details: (id: string) => `${ROOTS.DASHBOARD}/hsse/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/hsse/${id}/edit`,
    },
    phanhe: {
      root: `${ROOTS.DASHBOARD}/phanhe`,
      admin: `${ROOTS.DASHBOARD}/phanhe/admin`,
    },
    beboi: {
      root: `${ROOTS.DASHBOARD}/beboi`,
      admin: `${ROOTS.DASHBOARD}/beboi/admin`,
      new: `${ROOTS.DASHBOARD}/beboi/new`,
      phanquyen: `${ROOTS.DASHBOARD}/beboi/phanquyen`,
      details: (id: string) => `${ROOTS.DASHBOARD}/beboi/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/beboi/${id}/edit`,
      analytics: `${ROOTS.DASHBOARD}/beboi/analytics`,
    },
    report: {
      anninh_lamsach: `${ROOTS.DASHBOARD}/report/anninh-lamsach`,
      anninh_logistics: `${ROOTS.DASHBOARD}/report/anninh-logistics`,
      dien: `${ROOTS.DASHBOARD}/report/dien`,
      dien_analytics: `${ROOTS.DASHBOARD}/report/dien-analytics`,
    },
    thangmay: {
      root: `${ROOTS.DASHBOARD}/thangmay`,
      analytics: `${ROOTS.DASHBOARD}/thangmay/analytics`,
    },
    pccc: {
      root: `${ROOTS.DASHBOARD}/pccc`,
      analytics: `${ROOTS.DASHBOARD}/pccc/analytics`,
    },
    anninh: {
      root: `${ROOTS.DASHBOARD}/an-ninh`,
      baocao: {
        root: `${ROOTS.DASHBOARD}/an-ninh/bao-cao`,
        list_bc_loi: `${ROOTS.DASHBOARD}/an-ninh/bao-cao/list-bc-loi`,
        list_bc_congcu: `${ROOTS.DASHBOARD}/an-ninh/bao-cao/list-bc-congcu`,
        list_bc_daotao: `${ROOTS.DASHBOARD}/an-ninh/bao-cao/list-bc-daotao`,
        chamcong: `${ROOTS.DASHBOARD}/an-ninh/bao-cao/an-bc-chamcong`,
        new: `${ROOTS.DASHBOARD}/an-ninh/bao-cao/new`,
        details: (id: number) => `${ROOTS.DASHBOARD}/an-ninh/bao-cao/${id}`,
        edit: (id: number) => `${ROOTS.DASHBOARD}/an-ninh/bao-cao/${id}/edit`,
      },
      baocaothongke: `${ROOTS.DASHBOARD}/an-ninh/bao-cao-thong-ke`,
    },
    baotribaoduong: {
      root: `${ROOTS.DASHBOARD}/bao-tri-bao-duong`,
      nhomthietbi: `${ROOTS.DASHBOARD}/bao-tri-bao-duong/nhom-thiet-bi`,
      thietbi: `${ROOTS.DASHBOARD}/bao-tri-bao-duong/thiet-bi`,
      thietbiduan: `${ROOTS.DASHBOARD}/bao-tri-bao-duong/thiet-bi-du-an`,
      phieubaotri: {
        root: `${ROOTS.DASHBOARD}/bao-tri-bao-duong/phieu-bao-tri`,
        details: (id: string) => `${ROOTS.DASHBOARD}/bao-tri-bao-duong/phieu-bao-tri/${id}`,
      },
    },
    baocaothang: {
      root: `${ROOTS.DASHBOARD}/bao-cao-thang`,
    },
    nhathau: {
      root: `${ROOTS.DASHBOARD}/dang-ky-thi-cong`,
      analytics: `${ROOTS.DASHBOARD}/dang-ky-thi-cong/analytics`,
    },
    p0: {
      root: `${ROOTS.DASHBOARD}/p0`,
      admin: `${ROOTS.DASHBOARD}/p0/admin`,
      new: `${ROOTS.DASHBOARD}/p0/new`,
      phanquyen: `${ROOTS.DASHBOARD}/p0/phanquyen`,
      details: (id: string) => `${ROOTS.DASHBOARD}/p0/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/p0/${id}/edit`,
      analytics: `${ROOTS.DASHBOARD}/p0/analytics`,
    },
    toanha: {
      root: `${ROOTS.DASHBOARD}/toanha`,
      new: `${ROOTS.DASHBOARD}/toanha/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/toanha/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/toanha/${id}/edit`,
    },
    userAdmin: {
      root: `${ROOTS.DASHBOARD}/user/`,
      profile: `${ROOTS.DASHBOARD}/user/`,
    },
    room: {
      root: `${ROOTS.DASHBOARD}/room`,
      new: `${ROOTS.DASHBOARD}/room/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/room/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/room/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/room/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/room/${MOCK_ID}/edit`,
      },
    },
    orderBooking: {
      root: `${ROOTS.DASHBOARD}/order-booking`,
      list: `${ROOTS.DASHBOARD}/order-booking/services`,
      details: (id: string | number) => `${ROOTS.DASHBOARD}/order-booking/${id}`,
      edit: (id: string | number) => `${ROOTS.DASHBOARD}/order-booking/${id}/edit`,
      detail_service: (id: string | number) => `${ROOTS.DASHBOARD}/order-booking/services/${id}`,
      edit_service: (id: string | number) => `${ROOTS.DASHBOARD}/order-booking/services/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order-booking/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/order-booking/${MOCK_ID}/edit`,
      },
    },
    accountEmployee: {
      root: `${ROOTS.DASHBOARD}/account-employee`,
    },

    user: {
      root: `${ROOTS.DASHBOARD}/userMinimal`,
      new: `${ROOTS.DASHBOARD}/userMinimal/new`,
      list: `${ROOTS.DASHBOARD}/userMinimal/list`,
      cards: `${ROOTS.DASHBOARD}/userMinimal/cards`,
      profile: `${ROOTS.DASHBOARD}/userMinimal/profile`,
      account: `${ROOTS.DASHBOARD}/userMinimal/account`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/userMinimal/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/userMinimal/${MOCK_ID}/edit`,
      },
    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/product/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/product/${MOCK_ID}/edit`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      details: (title: string) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}`,
      edit: (title: string) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id: string) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/job/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
      },
    },
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
    index_report: {
      root: `${ROOTS.DASHBOARD}/index_report`,
      new: `${ROOTS.DASHBOARD}/index_report/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/index_report/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/index_report/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/index_report/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/index_report/${MOCK_ID}/edit`,
      },
    },
  },
};
